import { FormTextInput } from '@components/form';
import * as yup from 'yup';

export const volumeDescriptionSchema = yup.string();

export const VolumeDescriptionField = () => {
  return <FormTextInput label="Description" name="description" multiline rows={3} />;
};
